/**
 * Created by matei on 16/11/2019
 */

import AppContainer from './app-container';

export default AppContainer;
